
  document.addEventListener('DOMContentLoaded', function() {
    const navItems = document.querySelectorAll('.desktop-nav-item');
    const indicator = document.querySelector('.nav-indicator');
    const overlay = document.getElementById('desktopOverlay');
    const overlayContent = document.getElementById('overlayContent');
    const header = document.querySelector('.desktop-header');

    let activeTab = null;

    function updateHeaderHeight() {
      if (header) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      }
    }

    function sortMobileBlogCards() {
      if (window.innerWidth > 899) return;

      const blogLists = document.querySelectorAll('[data-mobile-blog-list]');
      blogLists.forEach(list => {
        const cards = Array.from(list.querySelectorAll('[data-mobile-blog-card]'));
        if (!cards.length) return;

        cards.sort((a, b) => {
          const aDate = parseInt(a.getAttribute('data-published-at') || '0', 10);
          const bDate = parseInt(b.getAttribute('data-published-at') || '0', 10);
          return bDate - aDate;
        });

        cards.forEach(card => list.appendChild(card));

        cards.forEach((card, index) => {
          card.style.display = index < 3 ? '' : 'none';
        });
      });
    }

    updateHeaderHeight();
    sortMobileBlogCards();

    window.addEventListener('resize', function() {
      updateHeaderHeight();
      sortMobileBlogCards();

      if (overlay.classList.contains('active')) {
        setTimeout(() => {
          manageOverlayScroll();
        }, 100);
      }
    });

    navItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const tabName = this.dataset.tab;
        
        if (activeTab === tabName) {
          closeDesktopOverlay();
          return;
        }

        activeTab = tabName;
        updateIndicator(this);
        navItems.forEach((n) => n.classList.toggle('is-open', n === this));
        
        const tabContent = document.getElementById(tabName);
        if (tabContent) {
          overlayContent.innerHTML = tabContent.innerHTML;
          if (window.gmDollApply) window.gmDollApply();
          overlay.classList.add('active');
          window.scrollTo({ top: 0, behavior: 'smooth' });
          
          setTimeout(() => {
            manageOverlayScroll();
          }, 50);
        }
      });
    });

    function updateIndicator(activeItem) {
      const itemRect = activeItem.getBoundingClientRect();
      const navRect = activeItem.parentElement.getBoundingClientRect();
      indicator.style.left = (itemRect.left - navRect.left) + 'px';
      indicator.style.width = itemRect.width + 'px';
      indicator.classList.add('active');
    }

    window.closeDesktopOverlay = function() {
      navItems.forEach((n) => n.classList.remove('is-open'));
      overlay.classList.remove('active');
      indicator.classList.remove('active');
      activeTab = null;
      document.body.classList.remove('overlay-open');
      document.body.classList.remove('overlay-scroll-enabled');
      document.documentElement.style.overflow = '';
      document.body.style.height = '';
      document.body.style.minHeight = '';
    };

    function manageOverlayScroll() {
      const overlayHeight = overlay.scrollHeight;
      const viewportHeight = window.innerHeight;
      const headerHeight = header ? header.offsetHeight : 120;
      const headerTop = 8;
      const totalNeededHeight = headerTop + headerHeight + overlayHeight;
      const isBoutiqueLayout = overlayContent.querySelector('.boutique-layout') !== null;
      
      if (isBoutiqueLayout) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.height = '100vh';
        document.body.style.minHeight = '';
        document.body.classList.add('overlay-open');
        document.body.classList.remove('overlay-scroll-enabled');
        return;
      }
      
      if (totalNeededHeight > viewportHeight) {
        document.documentElement.style.overflow = 'auto';
        document.body.style.height = 'auto';
        document.body.style.minHeight = totalNeededHeight + 'px';
        document.body.classList.remove('overlay-open');
        document.body.classList.add('overlay-scroll-enabled');
      } else {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.height = '100vh';
        document.body.style.minHeight = '';
        document.body.classList.add('overlay-open');
        document.body.classList.remove('overlay-scroll-enabled');
      }
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeDesktopOverlay();
      }
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeDesktopOverlay();
      }
    });
  });

  const HEART_WHITE = "https://cdn.shopify.com/s/files/1/0729/3983/1631/files/favori_image_grenadine.png?v=1747835462&width=48";
  const HEART_PINK = "https://cdn.shopify.com/s/files/1/0729/3983/1631/files/favori_image_rose_grenadine.png?v=1747835482";
  const ICON_ENREGISTRER = "https://cdn.shopify.com/s/files/1/0729/3983/1631/files/enregistrer.png?v=1773923018&width=100";

  let scrollPosition = 0;
  function lockScroll() {
    if (!document.body.classList.contains('scroll-locked')) {
      scrollPosition = window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      document.body.classList.add('scroll-locked');
    }
  }

  function unlockScroll() {
    if (document.body.classList.contains('scroll-locked')) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('scroll-locked');
      window.scrollTo(0, scrollPosition);
    }
  }

  function closeAllSearches() {
    document.getElementById('searchOverlayPanel').classList.remove('active');
    document.getElementById('searchBackdrop').classList.remove('active');
    unlockScroll();

    const desktopExpanded = document.getElementById('desktopSearchExpanded');
    if (desktopExpanded && desktopExpanded.classList.contains('active')) {
       desktopExpanded.classList.remove('active');
       document.getElementById('desktopSearchIcon').style.display = 'flex';
    }
  }

  function toggleDesktopSearch() {
    const searchExpanded = document.getElementById('desktopSearchExpanded');
    const searchIcon = document.getElementById('desktopSearchIcon');
    const searchPanel = document.getElementById('searchOverlayPanel');
    const input = document.getElementById('desktopLiveSearchInput');
    const backdrop = document.getElementById('searchBackdrop');
    const resultsContainer = document.getElementById('liveSearchResults');
    const popularSearches = document.getElementById('popularSearches');

    if (searchExpanded.classList.contains('active')) {
      searchExpanded.classList.remove('active');
      searchIcon.style.display = 'flex';
      searchPanel.classList.remove('active');
      backdrop.classList.remove('active');
      unlockScroll();
    } else {
      if(typeof closeDesktopOverlay === 'function') closeDesktopOverlay();
      
      searchExpanded.classList.add('active');
      searchIcon.style.display = 'none';
      searchPanel.classList.add('active');
      backdrop.classList.add('active');
      lockScroll();
      
      if(input.value.trim() === '') {
        resultsContainer.style.display = 'none';
        popularSearches.style.display = 'block';
      }
      
      setTimeout(() => input.focus(), 100);
    }
  }

  function toggleMobileSearch() {
    const searchPanel = document.getElementById('searchOverlayPanel');
    const input = document.getElementById('mobileLiveSearchInput');
    const resultsContainer = document.getElementById('liveSearchResults');
    const popularSearches = document.getElementById('popularSearches');
    const backdrop = document.getElementById('searchBackdrop');
    
    if (searchPanel.classList.contains('active')) {
      searchPanel.classList.remove('active');
      backdrop.classList.remove('active');
      unlockScroll();
    } else {
      if(typeof closeMobileMenu === 'function') closeMobileMenu();
      if(typeof closeDesktopOverlay === 'function') closeDesktopOverlay();
      
      searchPanel.classList.add('active');
      backdrop.classList.add('active');
      lockScroll();
      
      if(input.value.trim() === '') {
        resultsContainer.style.display = 'none';
        popularSearches.style.display = 'block';
      }
      
      setTimeout(() => input.focus(), 100);
    }
  }

  function handleSearchInput(e) {
    const rawQuery = e.target.value; 
    const query = rawQuery.trim();
    
    if (e.target.id === 'desktopLiveSearchInput') {
      document.getElementById('mobileLiveSearchInput').value = rawQuery;
    } else {
      document.getElementById('desktopLiveSearchInput').value = rawQuery;
    }

    const resultsContainer = document.getElementById('liveSearchResults');
    const popularSearches = document.getElementById('popularSearches');

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      resultsContainer.style.display = 'none';
      popularSearches.style.display = 'block';
      return;
    }

    popularSearches.style.display = 'none';
    resultsContainer.style.display = 'flex';

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products;
        if (products && products.length > 0) {
          let html = '';
          products.forEach(product => {
            let numericPrice = parseFloat(String(product.price).replace(/[^0-9.,]/g, '').replace(',', '.'));
            let formattedPrice = isNaN(numericPrice) ? product.price : numericPrice.toFixed(2).replace('.', ',') + '€';
            
            html += `
              <div class="search-item">
                <a href="${product.url}" class="search-item-link">
                  <img src="${product.image}" alt="${product.title}" loading="lazy" decoding="async">
                  <div class="search-item-info">
                    <h4 class="search-item-name">${product.title}</h4>
                    <span class="search-item-brand">
                      <img src="${ICON_ENREGISTRER}" alt="Marque" loading="lazy" decoding="async">
                      ${product.vendor}
                    </span>
                  </div>
                </a>
                <div class="search-item-right">
                  <span class="search-item-price">${formattedPrice}</span>
                  <button class="search-item-favori-btn" onclick="toggleFavoriSearch(this, event)">
                    <img src="${HEART_WHITE}" alt="Ajouter aux favoris" loading="lazy" decoding="async">
                  </button>
                </div>
              </div>
            `;
          });
          resultsContainer.innerHTML = html;
        } else {
          resultsContainer.innerHTML = '<p style="text-align:center; padding: 20px; color: #666; font-size: 14px;">Aucun résultat trouvé.</p>';
        }
      })
      .catch(err => console.error('Erreur recherche:', err));
  }

  document.getElementById('desktopLiveSearchInput').addEventListener('input', handleSearchInput);
  document.getElementById('mobileLiveSearchInput').addEventListener('input', handleSearchInput);

  function toggleFavoriSearch(btn, event) {
    event.preventDefault();
    event.stopPropagation();
    const img = btn.querySelector('img');
    img.src = img.src.includes("rose") ? HEART_WHITE : HEART_PINK;
  }

  function toggleDrawer() {
    if (document.documentElement.classList.contains('gr-menu-open')) { closeMobileMenu(); return; }
    var w = document.querySelector('.mobile-header-wrapper');
    if (w) document.documentElement.style.setProperty('--gr-menu-top', (w.getBoundingClientRect().bottom + 8) + 'px');
    document.documentElement.classList.add('gr-menu-open');
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('drawer').classList.add('open');
    document.body.classList.add('menu-open');
    lockScroll();
  }

  function closeMobileMenu() {
    document.documentElement.classList.remove('gr-menu-open');
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('drawer').classList.remove('open');
    document.body.classList.remove('menu-open');
    hideMobileMegaMenu();
    unlockScroll();
  }

  function showMobileMegaMenu(panelId) {
    const drawer = document.getElementById('drawer');
    drawer.style.display = 'none';
    document.getElementById(panelId).style.display = 'block';
    lockScroll();

    setTimeout(() => {
      const panel = document.getElementById(panelId);
      if (!panel) return;

      const lists = panel.querySelectorAll('[data-mobile-blog-list]');
      lists.forEach(list => {
        const cards = Array.from(list.querySelectorAll('[data-mobile-blog-card]'));
        cards.sort((a, b) => {
          const aDate = parseInt(a.getAttribute('data-published-at') || '0', 10);
          const bDate = parseInt(b.getAttribute('data-published-at') || '0', 10);
          return bDate - aDate;
        });

        cards.forEach(card => list.appendChild(card));
        cards.forEach((card, index) => {
          card.style.display = index < 3 ? '' : 'none';
        });
      });
    }, 10);
  }

  function hideMobileMegaMenu() {
    // "Mon compte" : on revient a l'ecran de depart (Se connecter / Je m'inscris)
    document.querySelectorAll('.gm-login').forEach(function (box) { box.hidden = true; });
    document.querySelectorAll('[data-gm-login-open].gm-hide').forEach(function (b) { b.classList.remove('gm-hide'); });
    document.querySelectorAll('.gm-login-on').forEach(function (el) { el.classList.remove('gm-login-on'); });
    const panels = document.querySelectorAll('.mobile-mega-menu-panel');
    panels.forEach(panel => panel.style.display = 'none');
    const drawer = document.getElementById('drawer');
    drawer.style.display = 'flex';
  }

  function openPopup(event) {
    event.stopPropagation();
    document.getElementById('popup').style.display = 'block';
    document.getElementById('overlay').style.display = 'block';
    document.body.classList.add('menu-open');
    lockScroll();
  }

  function closePopup() {
    document.getElementById('popup').style.display = 'none';
    document.getElementById('overlay').style.display = 'none';
    document.body.classList.remove('menu-open');
    unlockScroll();
  }

  function toggleFavori(img) {
    img.src = img.src.includes("rose") ? HEART_WHITE : HEART_PINK;
  }
